<script>
    import { closeModal, onBeforeClose } from "svelte-modals";
    import { fly } from "svelte/transition";
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import InputField from "../Forms/InputField.svelte";
    import Button from "../Button/Button.svelte";
    import ButtonPromise from "../Button/ButtonPromise.svelte";

    export let isOpen;
    export let title;
    export let message;
    export let onConfirm;
    export let canClose;
    export let valueType = yup.string();
    export let extraButtons = [];
    export let onSubmitPromise = null;
    export let placeholder = "";

    const {
        form,
        handleChange,
        handleSubmit,
        errors,
        isValid
    } = createForm({
        initialValues: { value: "" },
        validationSchema: yup.object().shape({ value: valueType }),
        onSubmit: (form) => onConfirm(form.value),
    });

    onBeforeClose(() => $canClose)
</script>

{#if isOpen}
    <div
        class="custom-modal shadow-md flex flex-col gap-4 justify-between h-auto"
        transition:fly={{ y: -100 }}
        on:introstart
        on:outroend
    >
        <div class="flex flex-col gap-1">
            <div class="text-3xl font-bold text-bl">{title}</div>
            <div class="text-xl">{message}</div>
        </div>

        <InputField
            isRequired={false}
            name="value"
            handleChange={handleChange}
            bind:value={$form.value}
            bind:errorText={$errors.value}
            placeholder="{placeholder}"
        />

        <div class="flex flex-col gap-2">
            <div class="flex gap-2">
                <ButtonPromise
                    handleClick="{() => handleSubmit()}"
                    promise="{$onSubmitPromise}"
                    isDisabled={!$isValid}
                    buttonClass="bg-lightBlue-500 text-center font-semibold text-white w-1/2"
                    content="Conferma"
                />

                <Button
                    handleClick="{closeModal}"
                    disabled={$canClose}
                    buttonClass="bg-blueGray-600 text-center font-semibold text-white w-1/2"
                    content="Annulla"
                />
            </div>

            {#each extraButtons as extraButton}
                <Button {...extraButton} />
            {/each}
        </div>

    </div>
{/if}